import { DestroyableObstacle } from "../destroyableObstacle";
import { ParticleType } from "../particleType";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";

export class Fence extends DestroyableObstacle {
	static key = "Fence";
	constructor(xy: XY) {
		super(xy);
	}

	getDebrisParticleType(): ParticleType {
		return ParticleType.METAL_DEBRIS;
	}

	override isGasPermeable(): boolean {
		return true;
	}

	static deserialize(data: any): Fence {
		const f = new Fence(deserializeXY(data.xy));
		f.restoreBaseFields(data);
		return f;
	}
}
